import { CLOSE_MODAL, OPEN_MODAL } from './ActionTypes';
import { MODAL_TYPES } from '../constants/ModalConstants';
export const openModal = (modalType, modalProps) => ({
  type: OPEN_MODAL,
  modalType,
  modalProps
});
export const closeModal = () => ({
  type: CLOSE_MODAL
});
export const openDeleteModal = ({
  selectedInteractiveIds,
  name,
  selectedObjectIds,
  isBulkAction
}) => openModal(MODAL_TYPES.DELETE, {
  selectedInteractiveIds,
  name,
  selectedObjectIds,
  isBulkAction
});
export const openRunAbTestModal = ({
  name,
  interactiveId
}) => openModal(MODAL_TYPES.RUN_AB_TEST, {
  name,
  selectedInteractiveId: interactiveId
});
export const openPickAbTestWinnerModal = ({
  abTestId,
  master,
  variant
}) => openModal(MODAL_TYPES.PICK_AB_TEST_WINNER, {
  abTestId,
  master,
  variant
});
export const openCloneModal = ({
  interactiveId,
  name,
  isAbTest
}) => openModal(MODAL_TYPES.CLONE, {
  name,
  selectedInteractiveId: interactiveId,
  isAbTest
});
export const openUnpublishModal = ({
  interactiveId
}) => openModal(MODAL_TYPES.UNPUBLISH, {
  interactiveId
});
export const openArchiveModal = ({
  interactiveIds,
  name,
  objectIds,
  shouldArchive
}) => openModal(MODAL_TYPES.ARCHIVE, {
  name,
  selectedInteractiveIds: interactiveIds,
  selectedObjectIds: objectIds,
  shouldArchive
});
export const openEmbedModal = ({
  interactiveId
}) => openModal(MODAL_TYPES.EMBEDDING_INFO, {
  interactiveId
});
export const openPreviewModal = modalProps => openModal(MODAL_TYPES.PREVIEW_CTA, modalProps);
export const openDetailsPanel = panelProps => openModal(MODAL_TYPES.DETAILS_PANEL, panelProps);
export const openManageAccessPanel = ({
  objects
}) => openModal(MODAL_TYPES.MANAGE_ACCESS, {
  objects
});